<kendo-dialog-titlebar>
    Encounter Attendance - Present
</kendo-dialog-titlebar>
<div class="k-d-grid k-gap-y-sm">
    <section class="k-d-grid k-gap-y-lg">
        <h6 class="k-my-0">Session Details</h6>
        <div class="k-d-flex gap-20">
            <div class="student-card k-w-full">
                <div class="k-d-flex !k-justify-content-between">
                    <div>
                        <div class="k-d-flex k-align-items-center k-gap-x-sm">
                            <fa-icon [icon]="faCircleUser" size="xl" class="k-mt-2"></fa-icon>
                            <strong>{{ studentInfo?.studentName }}</strong>
                        </div>
                        <p style="margin-left: 35px;" class="k-mt-0 k-mb-0">ID: {{ studentInfo?.studentId }}</p>
                    </div>
                    <div class="k-d-grid">
                        <p class="!k-m-0">{{ studentInfo?.mandatedDescription }}</p>
                        <p class="!k-m-0">{{ studentInfo?.mandatedLocation }}</p>
                    </div>
                </div>
            </div>
            <div class="k-d-grid session-card k-w-full k-gap-y-lg">
                <strong>Scheduled Session: {{meetingStartTime | date:'EEE MMM d h:mm a'}} ({{ studentInfo?.scheduledSessionText }})</strong>
                <form [formGroup]="firstSessionForm">
                    <div class="k-d-flex k-gap-lg">
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">
                                <input type="checkbox" id="firstAttendCheckbox" kendoCheckBox
                                    formControlName="isFirstAttend" />
                                <kendo-label class="k-checkbox-label" [for]="'firstAttendCheckbox'"
                                    text="First attend"></kendo-label>
                            </div>
                        </kendo-formfield>
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">
                                <input type="checkbox" id="firstEncounterCheckbox" kendoCheckBox
                                    formControlName="isFirstEncounter" />
                                <kendo-label class="k-checkbox-label" [for]="'firstEncounterCheckbox'"
                                    text="First encounter"></kendo-label>
                            </div>
                        </kendo-formfield>
                    </div>
                </form>
            </div>
        </div>
    </section>
    @if(showAutoFilledCheckboxes){
    <div class="autofilled-checkbox-card">
        <p class="k-m-0">The system has auto-filled the above checkboxes on your behalf because there is no existing
            first attend and/or first encounter date for this mandate.</p>
    </div>
    }
    @if(showCertifyingWarningMessage){
    <div class="certify-first-attend-card">
        <p class="k-m-0">
            <strong>Warning:</strong>
            {{
            "You are certifying a first attend date when a first attend date already exists for {Mandate - Short
            Description} for reporting period {Mandate - Reporting Period}. Updating the first attend date will notify
            your supervisor."
            }}
        </p>
    </div>
    }
    @if(requireReasonForDelay){
    <form [formGroup]="delayForm">
        <div class="delay-first-attend-card k-d-grid k-gap-y-lg">
            <div>
                <p class="k-m-0 !k-font-bold k-text-error"><fa-icon icon="triangle-exclamation"
                        class="k-mr-4"></fa-icon>Delay
                    in First
                    Attend
                    Detected</p>
                <p class="k-mt-0 k-mb-0 k-ml-8">The indicated first attend date for this child’s mandate (MM/DD/YYYY) is
                    5
                    school day(s)
                    after the assignment or service start date. Please explain the reason for delay below.</p>
            </div>
            <div class="k-d-flex k-gap-x-md">
                <kendo-formfield class="k-w-full">
                    <kendo-floatinglabel text="Reason for Delay *">
                        <kendo-dropdownlist placeholder='Reason for Delay *' [data]="reasonForDelayList"
                            [valueField]="'id'" [textField]="'description'"
                            formControlName="reasonForDelay"></kendo-dropdownlist>
                    </kendo-floatinglabel>
                    <div class="k-text-error k-text-xs" *ngIf="
            attendanceForm.get('reasonForDelay')?.touched &&
            attendanceForm.get('reasonForDelay')?.invalid
          " role="alert">
                        Error: Reason for Delay is required for encounters older than 45 days.
                    </div>
                </kendo-formfield>
                <ng-container *ngIf="isOtherReasonSelected">
                    <kendo-formfield class="k-w-full">
                        <kendo-label text="Other Reason *">
                            <kendo-textbox placeholder='Please Specify'
                                formControlName="reasonForDelayOthers"></kendo-textbox>
                        </kendo-label>
                        <div class="k-text-error k-text-xs" *ngIf="
          attendanceForm.get('reasonForDelayOthers')?.touched &&
          attendanceForm.get('reasonForDelayOthers')?.invalid
        " role="alert">
                            Error: Other Reason is required when 'Other' is selected.
                        </div>
                    </kendo-formfield>
                </ng-container>
            </div>
        </div>
    </form>
    }
    <div class="k-d-flex gap-20">
        <div [class]="comparePreviousSessionNotes ? 'k-flex-basis-2/4 k-bg-white' : 'k-flex-basis-full k-bg-white'">
            <section class="k-my-6">
                <kendo-formfield>
                    <div class="k-d-flex k-gap-lg">
                        <kendo-switch [(ngModel)]="comparePreviousSessionNotes"
                            (valueChange)="onComparePreviousToggle($event)"
                            [disabled]="!showComparePreviousSessionNotes"></kendo-switch>
                        <kendo-label text="Compare Previous Session Notes">
                        </kendo-label>
                    </div>
                </kendo-formfield>
            </section>
            <form [formGroup]="attendanceForm" class="k-d-grid k-gap-y-xl">
                <section class="k-d-grid k-gap-y-lg">
                    <div>
                        <h6 class="k-my-0">Annual Goals Addressed *</h6>
                        <p style="color: var(--tb-kendo-neutral-110);" class="k-m-0">Please mark the annual goal(s) that
                            were
                            addressed
                            during
                            the
                            session.

                        </p>
                    </div>
                    <div class="k-d-grid k-gap-y-md" [ngClass]="{
      'required-error':
        annualGoalsFA.touched && annualGoalsFA.invalid
    }">
                        <label class="k-d-flex k-align-items-start k-gap-3"
                            *ngFor="let goal of annualGoals; let i = index">
                            <input type="checkbox" kendoCheckBox [formControl]="getGoalControl(i)"
                                [attr.aria-label]="'Annual Goals Addressed: ' + goal.anualGoalName" />
                            <p class="k-m-0">{{ goal.anualGoalName }}</p>
                        </label>
                    </div>
                </section>
                <div class="k-text-error k-text-xs" *ngIf="annualGoalsFA.touched && annualGoalsFA.invalid" role="alert">
                    Please select at least one annual goal.
                </div>
                <span class="k-form-separator"></span>
                <section class="k-d-grid k-gap-y-lg" *ngIf="isCptApplicable && cptCodes.length > 0">
                    <div>
                        <h5 class="k-my-0">CPT Codes Addressed <span
                                *ngIf="isCptApplicable && cptCodes.length > 0">*</span></h5>
                        <p class="k-m-0" style="color: var(--tb-kendo-neutral-110);">Please mark the CPT code(s) that were addressed during the session.</p>
                    </div>
                    <div class="k-d-grid k-gap-y-md" [ngClass]="{
      'required-error':
        cptCodesFA.touched && cptCodesFA.invalid
    }">
                        <label class="k-d-flex k-align-items-start k-gap-3"
                            *ngFor="let item of cptCodes; let i = index">
                            <input type="checkbox" kendoCheckBox [formControl]="getCptControl(i)"
                                [attr.aria-label]="'CPT Codes Addressed: ' + item.cptCode + ' ' + item.cptCodeDescription" />
                            <p class="k-d-flex k-m-0 k-gap-x-md cpt-code-item"><strong>{{ item.cptCode }}</strong> {{
                                item.cptCodeDescription }}</p>
                        </label>
                    </div>
                    @if(getCptErrorMessage()){
                    <div class="cpt-codes-error">
                        <p class="k-m-0 !k-font-bold k-text-error">
                            <fa-icon icon="triangle-exclamation" class="k-mr-4"></fa-icon>
                            {{ getCptErrorMessage() }}
                        </p>
                    </div>
                    }
                </section>
                <div class="k-text-error k-text-xs" *ngIf="isCptApplicable && cptCodesFA.touched && cptCodesFA.invalid"
                    role="alert">
                    Please select at least one CPT code.
                </div>
                <span class="k-form-separator" *ngIf="isCptApplicable"></span>
                <section class="k-d-grid k-gap-y-lg">
                    <h5 class="k-my-0">Session Notes</h5>
                    <kendo-formfield class="k-w-full">
                        <kendo-label text="Progress Indicator *">
                            <kendo-dropdownlist [data]="progressIndicators" placeholder='Progress Indicator *'
                                [valueField]="'id'" [textField]="'description'"
                                formControlName="progressIndicator"></kendo-dropdownlist>
                        </kendo-label>
                        <div class="k-text-error k-text-xs k-mt-2" *ngIf="attendanceForm.get('progressIndicator')?.touched &&
              attendanceForm.get('progressIndicator')?.invalid" role="alert">
                            Error: Field is required.
                        </div>
                    </kendo-formfield>
                    <kendo-formfield>
                        <kendo-label text="Session Notes *">
                            <kendo-textarea rounded="medium" [rows]="3" [maxlength]="sessionNotesMaxValue"
                                formControlName="sessionNotes"></kendo-textarea>
                        </kendo-label>
                        <!-- character counter -->
                        <div class="k-text-xs k-mt-1 char-counter">
                            {{ attendanceForm.get('sessionNotes')?.value?.length || 0 }}/8000 characters
                        </div>
                        <!-- validation messages -->
                        <div class="k-text-error k-text-xs" *ngIf="
    attendanceForm.get('sessionNotes')?.errors &&
    (attendanceForm.get('sessionNotes')?.dirty ||
     attendanceForm.get('sessionNotes')?.touched)
  " role="alert">
                            <ng-container *ngIf="attendanceForm.get('sessionNotes')?.errors?.['required']">
                                Error: Field is required.
                            </ng-container>
                            <ng-container *ngIf="attendanceForm.get('sessionNotes')?.errors?.['minlength']">
                                Must be at least 20 characters.
                            </ng-container>
                        </div>
                    </kendo-formfield>
                </section>
            </form>
        </div>
        @if(comparePreviousSessionNotes){
        <kendo-card class="k-p-4" [ngClass]="{
    'k-flex-basis-2/4': comparePreviousSessionNotes,
    'k-bg-grey': comparePreviousSessionNotes,
    'k-w-full': comparePreviousSessionNotes
  }">
            <form [formGroup]="previousSessionNotesForm" class="k-d-grid k-gap-y-xl">
                <!-- <section class="k-my-6"> -->
                <kendo-formfield class="k-w-full">
                    <kendo-label text="Date Time" labelCssClass="hidden-label">
                        <kendo-dropdownlist formControlName="historySessionDate" [data]="previousSessions"
                            [textField]="'historySessionDate'" [valuePrimitive]="false"
                            (valueChange)="onHistoryChange($event)">
                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                                {{ dataItem.historySessionDate | date: 'MMM dd, yyyy hh:mm a' }}
                            </ng-template>

                            <ng-template kendoDropDownListValueTemplate let-dataItem>
                                {{ dataItem?.historySessionDate | date: 'MMM dd, yyyy hh:mm a' }}
                            </ng-template>
                        </kendo-dropdownlist>



                    </kendo-label>
                </kendo-formfield>
                <!-- </section> -->
                <!-- Annual Goals -->
                <section class="k-d-grid k-gap-y-lg">
                    <div>
                        <h6 class="k-my-0">Annual Goals Addressed *</h6>
                        <p class="k-m-0" style="color: var(--tb-kendo-neutral-110);">
                            Please mark the annual goal(s) that were addressed during the session.
                        </p>
                    </div>

                    <div class="k-d-grid k-gap-y-md">
                        <label class="k-d-flex k-align-items-start k-gap-3"
                            *ngFor="let goal of annualGoals; let i = index">
                            <input type="checkbox" kendoCheckBox [formControl]="getPreviousSessionGoalControl(i)"
                                [attr.aria-label]="'Previous session annual goal addressed: ' + goal.anualGoalName" />
                            <p class="k-m-0">{{ goal.anualGoalName }}</p>
                        </label>
                    </div>
                </section>

                <span class="k-form-separator"></span>

                <!-- CPT Codes -->
                <section class="k-d-grid k-gap-y-lg">
                    <div>
                        <h5 class="k-my-0">CPT Codes Addressed *</h5>
                        <p class="k-m-0" style="color: var(--tb-kendo-neutral-110);">Previous session CPT codes.</p>
                    </div>

                    <div class="k-d-grid k-gap-y-md">
                        <label class="k-d-flex k-align-items-start k-gap-3"
                            *ngFor="let item of cptCodes; let i = index">
                            <input type="checkbox" kendoCheckBox [formControl]="getPreviousSessionCptControl(i)"
                                [attr.aria-label]="'Previous session CPT code addressed: ' + item.cptCode + ' ' + item.cptCodeDescription" />
                            <p class="k-d-flex k-m-0 k-gap-x-md cpt-code-item"><strong>{{ item.cptCode }}</strong> {{
                                item.cptCodeDescription }}</p>
                        </label>
                    </div>
                </section>

                <span class="k-form-separator"></span>

                <!-- Progress Indicator -->
                <section class="k-d-grid k-gap-y-lg">
                    <h5 class="k-my-0">Session Notes</h5>

                    <kendo-formfield class="k-w-full">
                        <kendo-label text="Progress Indicator">
                            <kendo-dropdownlist [data]="progressIndicators" placeholder="Progress Indicator"
                                [valueField]="'id'" [textField]="'description'"
                                formControlName="progressIndicator" [readonly]="true"></kendo-dropdownlist>
                        </kendo-label>
                    </kendo-formfield>

                    <kendo-formfield>
                        <kendo-label text="Session Notes">
                            <kendo-textarea [rows]="3" formControlName="sessionNotes" [readonly]="true"></kendo-textarea>
                        </kendo-label>
                    </kendo-formfield>
                </section>

            </form>

        </kendo-card>

        }
    </div>
    <section class="k-d-grid k-gap-y-sm">
        <h5 class="k-my-0">Attached Document(s)</h5>
        <!-- Existing documents -->
        <div class="existing-documents">
            <ng-container *ngIf="hasExistingDocuments">
                <ul class="k-pl-4 k-m-0">
                    <li *ngFor="let doc of existingDocuments">
                        <div (click)="downloadDocument(doc)">
                            <a class="doc-name" >
                                {{ doc.documentName }}</a>

                        </div>
                    </li>
                </ul>
            </ng-container>
            <ng-container *ngIf="selectedAttachments.length">
                <ul class="k-pl-4 k-m-0">
                    <li *ngFor="let file of selectedAttachments">
                        <span class="doc-name">{{ file.name }}</span>
                    </li>
                </ul>
            </ng-container>
        </div>
        <!-- New uploads -->
        <kendo-fileselect appFileRestrictions [showFileList]="true" [multiple]="true"
            (valueChange)="onFilesChange($event)" dropZoneHint="Drop files here to upload">
        </kendo-fileselect>
    </section>
</div>

<kendo-dialog-actions>
    <button kendoButton themeColor="primary" (click)="onSave()" [disabled]="!canSave">Save</button>
</kendo-dialog-actions>